module.exports = __webpack_public_path__ + "static/media/pessoa.727b313f.jpg";